// src/routes/index.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Homepage from '../pages/HomePage';
import Events from '../pages/FindEvents';
import RecommendedEvents from '../pages/RecommendedEvents';
import PopularEvents from '../pages/PopularEvents';
import UpcomingEvents from '../pages/EventsNearYou';
import MyEvents from '../pages/MyEvents';
import MyBookings from '../pages/MyBookings';
import ProtectedRoute from '../components/ProtectedRoute';
import NotFound from '../pages/404';
import Account from '../pages/Account';
import CreateEvent from '../pages/CreateEvent';
import EditEvent from '../pages/EditEvent';
import About from '../pages/About';
import HelpCenter from '../pages/HelpCenter';
import Team from '../pages/Team';
import ContactUs from '../pages/ContactUs';
import FAQ from '../pages/FAQ';
import TermsOfService from '../pages/TermsOfService';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import CookiePolicy from '../pages/CookiePolicy';
import EventDetail from '../pages/EventDetail';
import Settings from '../pages/Settings/Settings';
import AccountDetails from '../pages/account-details/AccountDetails';
import ResetPassword from '../pages/ResetPassword';
import GoogleCallback from '../pages/GoogleCallback';
import CheckoutSuccess from '../pages/CheckoutSuccess';
import CheckoutCancel from '../pages/CheckoutCancel';

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={<Navigate to="/" replace />}
      />
      <Route 
        path="/register" 
        element={<Navigate to="/" replace />}
      />
      <Route 
        path="/reset-password" 
        element={
          isAuthenticated ? <Navigate to="/" replace /> : <ResetPassword />
        } 
      />
      <Route 
        path="/auth/google/callback" 
        element={<GoogleCallback />} 
      />
      <Route 
        path="/auth/callback" 
        element={<GoogleCallback />} 
      />
      <Route 
        path="/google/callback" 
        element={<GoogleCallback />} 
      />
      <Route 
        path="/callback" 
        element={<GoogleCallback />} 
      />
      <Route
        path="/"
        element={<Homepage />}
      />
      <Route
        path="/events"
        element={<Events />}
      />
      <Route
        path="/recommended-events"
        element={<RecommendedEvents />}
      />
      <Route
        path="/popular-events"
        element={<PopularEvents />}
      />
      <Route
        path="/upcoming-events"
        element={<UpcomingEvents />}
      />
      <Route
        path="/my-events"
        element={
          <ProtectedRoute>
            <MyEvents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-bookings"
        element={
          <ProtectedRoute>
            <MyBookings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account-details"
        element={
          <ProtectedRoute>
            <AccountDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-event"
        element={
          <ProtectedRoute>
            <CreateEvent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/about"
        element={<About />}
      />
      <Route
        path="/team"
        element={<Team />}
      />
      <Route
        path="/contact"
        element={<ContactUs />}
      />
      <Route
        path="/faq"
        element={<FAQ />}
      />
      <Route
        path="/help"
        element={<HelpCenter />}
      />
      <Route
        path="/terms"
        element={<TermsOfService />}
      />
      <Route
        path="/privacy"
        element={<PrivacyPolicy />}
      />
      <Route
        path="/cookies"
        element={<CookiePolicy />}
      />
      <Route
        path="/events/:eventId"
        element={<EventDetail />}
      />
      <Route
        path="/events/:eventId/edit"
        element={
          <ProtectedRoute>
            <EditEvent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/checkout/success"
        element={<CheckoutSuccess />}
      />
      <Route
        path="/payment/success"
        element={<CheckoutSuccess />}
      />
      <Route
        path="/checkout/cancel"
        element={<CheckoutCancel />}
      />
      <Route
        path="/payment/cancel"
        element={<CheckoutCancel />}
      />
      <Route 
        path="/" 
        element={<Navigate to="/" replace />} 
      />
      <Route path="/auth/callback*" element={<GoogleCallback />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;